<template>
  <div class="classification-container">
    <Row class="classification w bg-white" type="flex" justify="space-between" style="padding: 32px 35px 50px">
      <Col class="pc-select" :xs="24" :sm="24" :md="18" :lg="18">
        <div v-for="(item, index) in classificationList" :key="index" class="class-left fbox fbox-jb">
          <p class="magtop fsh">{{item.title}}</p>
          <div class="fg1 fbox fbox-w">
            <p v-for="(t, i) in item.class" :key="i" :class="{active: item.activeIndex == i}" @click="changeClass(i, index)">{{t.name || t.major}}</p>
          </div>
        </div>
      </Col>
      <div class="ph-select">
        <div v-for="(item, index) in classificationList" :key="index" class="class-left fbox fbox-jb">
          <p class="magtop fsh">{{item.title}}</p>
          <Select v-model="clickName" style="width:200px">
            <Option v-for="(t, i) in item.class" :key="i" :value="i">{{t.name || t.major}}</Option>
          </Select>
        </div>
      </div>
      <Col :xs="24" :sm="24" :md="5" :lg="5">
        <img @click="toAiMap" class="AiImg" src="https://qingbo-oss.oss-cn-beijing.aliyuncs.com/aa329ebd-bd1c-47ef-84b6-96786af17d98.png">
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'classification',
  props: {
    classificationList: {
      type: Array
    }
  },
  data () {
    return {
      clickName: ''
    }
  },
  watch: {
    clickName: function (e) {
      this.$emit('changeClass', { i: e, index: 0 })
    }
  },
  mounted () {
  },
  methods: {
    changeClass (i, index, t) {
      this.$emit('changeClass', { i, index })
    },
    toAiMap () {
      this.$router.push('/aiMap')
    }
  }
}
</script>

<style lang='scss' scoped>
.classification{
  border-radius: 10px;
}
.class-left{
  margin-top: 30px;
  &:nth-child(1){
    margin-top: 0;
  }
  &>p{
      font-size: 18px;
      color: #8E9299;
  }
  div{
    margin-left: 30px;
    p{
      margin-right: 30px;
      padding: 3px 20px;
      font-size: 18px;
      border-radius: 25px;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover{
        background: linear-gradient(138deg, #00C774 0%, #00C084 100%);
        color: #FFFFFF;
      }
    }
    .active{
      background: linear-gradient(138deg, #00C774 0%, #00C084 100%);
      color: #FFFFFF;
    }
  }
}
.AiImg{
  width: 214px;
  height: 77px;
  float: right;
  cursor: pointer;
}
.magtop{
  margin-top: 4px;
}
.pc-select{}
.ph-select{
  display: none;
  ::v-deep{
    .ivu-select-selection:hover{
      border-color: #20b573
    }
    .ivu-select-selection{
      border-color: #20b573
    }
    .ivu-select-item-selected{
      color: #20b573;
    }
  }
}

@media(max-width: 992px) {
  .pc-select{
    display: none;
  }
  .ph-select{
    display: block;
  }
  .AiImg{
    // float: none;
    // margin: 0 auto;
  }
}

</style>
